import { render, staticRenderFns } from "./WorkApprovalWorksGrid.vue?vue&type=template&id=73df7127&scoped=true"
import script from "./WorkApprovalWorksGrid.vue?vue&type=script&lang=js"
export * from "./WorkApprovalWorksGrid.vue?vue&type=script&lang=js"
import style0 from "./WorkApprovalWorksGrid.vue?vue&type=style&index=0&id=73df7127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73df7127",
  null
  
)

export default component.exports